import createConverter from './lib/create_converter';
import ChannelConfiguration from 'models/channel_configuration';

export default createConverter(ChannelConfiguration);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/channel_configuration_converter.js